import { html, LitElement, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { Story } from 'inkjs';

import '../parts/event';
import '../parts/monster';
import '../parts/card';
import '../components/comments';

import style from './event.scss';
import { DATA_EVENTS } from '../data/sources';
import { getNameFromURL, setTitle, trackPage } from '../shared/utils';

export class EventPage extends LitElement {

    static get properties() {
        return {
            name: String,
            output: String
        }
    }

    constructor() {
        super();
        this.name = null;   
        this.story = null;
        this.output = '';  
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();     
        trackPage();  
        this.name = getNameFromURL();
        setTitle('Event');        
    }

    processText(res){
        if(typeof res === 'string'){

            if(res.startsWith('>>>')){

                res = res.replace(/\>/g,'');
                let actions = res.split(';');
                res = actions.map(action=>{

                    if(action.startsWith('COMBAT:')){
                        let monster = action.replace('COMBAT:','').trim();
                        if(monster !== 'random')
                            return `<div class="bubble big">📖 COMBAT: <monster-part id="${monster}" inline="true"></monster-part></div>`;
                    }

                    if(action.startsWith('DIRECTCOMBAT:')){
                        let monster = action.replace('DIRECTCOMBAT:','').trim();
                        if(monster !== 'random')
                            return `<div class="bubble big">📖 DIRECTCOMBAT: <monster-part id="${monster}" inline="true"></monster-part></div>`;
                    }
        
                    if(action.startsWith('AREAEFFECT:')){
                        let effect = action.replace('AREAEFFECT:','').trim();                
                        return `<div class="bubble big">📖 AREAEFFECT: <card-part id="${effect}" inline="true"></card-part></div>`;
                    }

                    if(action.startsWith('REMOVEAREAEFFECT:')){
                        let effect = action.replace('REMOVEAREAEFFECT:','').trim();                
                        return `<div class="bubble big">📖 REMOVEAREAEFFECT: <card-part id="${effect}" inline="true"></card-part></div>`;
                    }
        
                    if(action.startsWith('ADDTALENT:')){
                        let effect = action.replace('ADDTALENT:','').trim();                
                        return `<div class="bubble big">📖 ADDTALENT: ${effect==='random'?effect:`<card-part id="${effect}" inline="true" talent="true"></card-part>`}</div>`;
                    }

                    if(action.startsWith('NEXTCARD:')){
                        let effect = action.replace('NEXTCARD:','').trim();                
                        return `<div class="bubble big">📖 NEXTCARD: <card-part id="${effect}" inline="true"></card-part></div>`;
                    }

                    if(action.startsWith('ADDCARD:')){
                        let effect = action.replace('ADDCARD:','').trim();                
                        return `<div class="bubble big">📖 ADDCARD: <card-part id="${effect}" inline="true"></card-part></div>`;
                    }

                    if(action.startsWith('ADDCURSE:')){
                        let effect = action.replace('ADDCURSE:','').trim();                
                        return `<div class="bubble big">📖 ADDCURSE: <card-part id="${effect}" inline="true"></card-part></div>`;
                    }

                    return `<div class="bubble big">📖 ${action}</div>`;

                }).join('<br>');

            }            
                
            return res;
        }
    }

    renderStory(){        
        return html`
            <p>${unsafeHTML(this.processText(this.output))}</p>
            ${this.story.currentChoices.length > 0 ? this.story.currentChoices.map((choice,i)=>{      
                let caption = '';
                let flag = '';
                let text_arr = choice.text.split(';');
                if(text_arr.length > 1){
                    flag = text_arr[0];
                    caption = text_arr[1];
                }else{
                    caption = text_arr[0];
                }
                if(flag.startsWith('card:')){
                    let c = flag.replace('card:','').trim();                
                    flag = `card:<card-part id="${c}" inline="true"></card-part>`;
                }
                if(flag.startsWith('talent:')){
                    let c = flag.replace('talent:','').trim();                
                    flag = `talent:<card-part id="${c}" inline="true"></card-part>`;
                }
                return html`
                    <div class="button" @click=${()=>{

                        this.story.ChooseChoiceIndex(choice.index);
                        if(this.story.canContinue){
                            this.output = '';
                            this.output = this.story.Continue();       
                        }                            

                    }}>${unsafeHTML(caption)}</div>${flag?html`<div class="bubble big">📖 ${unsafeHTML(flag)}</div>`:''}
                    <br>
                `;
            }) : html`
                ${this.story.canContinue?html`
                    <div class="button" @click=${()=>{
                        this.output = this.story.Continue();                        
                    }}>Continue</div>
                `:''}
            `}     
            <p style="margin-top:30px;"><div class="button" style="background:#999" @click=${()=>{
                        window.location.reload();                      
                    }}>Reset Event</div></p>       
        `;
    }

    render() {    
        const cls = DATA_EVENTS.filter(c=>c.name===this.name||
            (c.caption===this.name && ['Count Vesparin','Alchemist','Priest','Succubus','Enchanter'].indexOf(this.name)===-1))[0];
        setTitle(cls.caption||cls.name);
        if(!this.story && cls.text){
            this.story = new Story(cls.text);
            this.output = this.story.Continue();
        }
        return html`
            ${this.tooltip}     
            <h1>
                <div class="header-image"
                    style="cursor:auto;background-image:url(./images/events/${(cls.artwork || 'dt_portrait_bolgar').replace(/ /g, '%20')}.webp);">
                </div> ${cls.caption||cls.name}
            </h1>            
            <p class="flavor">${cls.desc}</p>
            ${cls.name === 'Shrine' ? html`
            ${DATA_EVENTS.filter(ev=>ev.type===10).map(ev=>html`
                <div class="row">
                    <event-part id=${ev.name}></event-part>
                </div>
            `)}
            `:''}
            ${cls.name === 'Opportunity' ? html`
            ${DATA_EVENTS.filter(ev=>ev.type===2).map(ev=>html`
                <div class="row">
                    <event-part id=${ev.name}></event-part>
                </div>
            `)}
            `:''}
            ${cls.name === 'NPC' ? html`
            ${DATA_EVENTS.filter(ev=>ev.type===0).map(ev=>html`
                <div class="row">
                    <event-part id=${ev.name}></event-part>
                </div>
            `)}
            `:''}
            ${cls.text?html`
            ${this.renderStory()}
            `:''}
            ${cls.related?.cards.length > 0 ?html`
                <h3>Related Cards (${cls.related.cards.length})</h3>
                ${cls.related.cards.map(c=>html`
                <div class="row">
                    <card-part id=${c}></card-part>
                </div>
                `)}
            `:''}
            ${cls.related?.talents.length > 0 ?html`
                <h3>Related Talents (${cls.related.talents.length})</h3>
                ${cls.related.talents.map(c=>html`
                <div class="row">
                    <card-part id=${c} talent="true"></card-part>
                </div>
                `)}
            `:''}
            ${cls.related?.monsters.length > 0 ?html`
                <h3>Related Monsters (${cls.related.monsters.length})</h3>
                ${cls.related.monsters.map(c=>html`
                <div class="row">
                    <monster-part id=${c}></monster-part>
                </div>
                `)}
            `:''}
            <comments-component path=${window.location.pathname}></comments-component>
        `;
    }
}

customElements.define('event-page', EventPage);